import React, { FC, ReactNode } from 'react'

export interface ContractInfoItemProps {
	label: string
	value: ReactNode
}

const ContractInfoItem: FC<ContractInfoItemProps> = ({ label, value }) => {
	return (
		<div className='child'>
			<p className='header dark:text-white'>{label}</p>
			<p className='text dark:text-text-grey-100'>{value}</p>
		</div>
	)
}

export default ContractInfoItem
